<template>
    <v-container ref="container" fluid :style="containerStyle" class="h-100 d-flex align-center">
        <v-card class="mx-auto pt-9 pb-10 px-12" min-width="420">
            <v-card-title class="text-h5 text-center text-wrap">
                {{ forgotPasswordStep ? $t('forgot_your_password') : $t('sign_in') }}
            </v-card-title>
            <NewForgotPasswordForm
                v-if="forgotPasswordStep"
                :is-b2b="forgotPasswordStep"
                class="pt-5"
                @switch-to-login="forgotPasswordStep = false"
            />
            <template v-else>
                <NewB2cAuthorizationForm
                    :has-access-to-registration="defaultStates.B2C_HAS_ACCESS_TO_REGISTRATION"
                    @click-forgot-password="forgotPasswordStep = true"
                />
            </template>
        </v-card>
    </v-container>
</template>

<script lang="ts">
    import {Vue, Component, Hook} from 'vue-facing-decorator'
    import ForgotPasswordForm from '@/components/account/forms/ForgotPasswordForm.vue'
    import NewB2cAuthorizationForm from '~/components/account/forms/NewB2cAuthorizationForm.vue'
    import {AUTH_EVENT, EventBus} from '@/utils/event-bus'
    import NewForgotPasswordForm from '~/components/account/forms/NewForgotPasswordForm.vue'

    @Component({
        components: {NewB2cAuthorizationForm, ForgotPasswordForm, NewForgotPasswordForm},
    })
    export class B2cAuthorizationPage extends Vue {
        forgotPasswordStep = false
        prevRoute = null

        @Hook
        beforeRouteEnter(to, from, next) {
            next(vm => {
                vm.prevRoute = from
            })
        }

        mounted() {
            EventBus.$on(AUTH_EVENT, this.onAuth)
        }

        beforeUnmount() {
            EventBus.$off(AUTH_EVENT, this.onAuth)
        }

        onAuth() {
            if (
                this.prevRoute?.path.includes('/search/') ||
                ['hotel', 'transfer', 'activity', 'hotelDirectory'].includes(this.prevRoute?.name)
            ) {
                this.$router.go(-1)
            } else {
                this.$router.push({name: 'home'})
            }
        }

        get containerStyle() {
            return {
                'background-image': 'url(/b2c-login-bg.jpg)',
                'background-size': 'cover',
                'background-position': '50%',
            }
        }
    }

    export default B2cAuthorizationPage
</script>
